import { useTranslation } from 'react-i18next';
import type { WeakTopic } from '../../types/admin';

interface Props {
  topics: WeakTopic[];
}

export default function WeakTopicsPanel({ topics }: Props) {
  const { t } = useTranslation();
  if (topics.length === 0) {
    return <p className="text-sm text-slate-500 dark:text-slate-400">{t('dashboard.weakTopics.empty')}</p>;
  }

  return (
    <div className="space-y-3">
      {topics.map((tp) => (
        <div key={tp.topic} className="rounded-xl border border-slate-200/70 bg-slate-50/60 p-3 ring-2 ring-red-500/30 dark:border-white/10 dark:bg-white/5 dark:ring-red-500/20">
          <div className="flex items-center justify-between mb-1">
            <span className="text-sm font-medium text-slate-800 dark:text-slate-200 truncate max-w-[60%]">{tp.topic}</span>
            <span className="font-mono text-sm font-bold text-red-600 dark:text-red-400">{tp.accuracy_percent}%</span>
          </div>
          <div className="h-1.5 w-full rounded-full bg-red-100 dark:bg-white/10">
            <div
              className="h-1.5 rounded-full bg-gradient-to-r from-red-500 to-amber-500"
              style={{ width: `${tp.accuracy_percent}%` }}
            />
          </div>
          <p className="mt-1 text-xs text-slate-500 dark:text-slate-500">
            {t('dashboard.weakTopics.correctOf', { correct: tp.total_correct, answered: tp.total_answered })}
          </p>
        </div>
      ))}
    </div>
  );
}
